import { getFormattedDateFromDate, twentyFourHourDateTimeFormat } from '@mmt/legacy-commons/Helpers/dateHelpers';
import { getRailsLanguageByKey, _label } from '../vernacular/AppLanguage';
import fecha from "fecha";

export const getSearchParams = (response, pageName) => {
  const {
    fromDateTime,
    fromCity,
    fromCityName,
    fromStationName,
    toCity,
    toCityName,
    toStationName,
  } = response;

  //parameters in number to use them in meta link
  const formattedDate = getFormattedDateFromDate(fromDateTime, 'YYYYMMDD');
  const fromCityCode = fromCity.toUpperCase();
  const toCityCode = toCity.toUpperCase();

  const searchParams = {
    searchContext: {
      language: getRailsLanguageByKey('cookieCode'),
      region: 'in',
      profile: 'personal',
      timestamp: new Date().getTime(),
      lob: 'rails',
      lobCategory: 'rails',

      fromDateTime: {
        ts: fromDateTime.getTime(),
        zone: 'IST',
        str: getFormattedDateFromDate(fromDateTime, twentyFourHourDateTimeFormat),
      },

      from: {
        lobCity: fromCityCode,
        cityName: fromCityName,
        lobCountry: 'India',
        countryCode: 'IN',
      },
      to: {
        lobCity: toCityCode,
        cityName: toCityName,
        lobCountry: 'India',
        countryCode: 'IN',
      },
      journeyType: 'OW',

      meta: {
        deeplink: `https://www.makemytrip.com/railways/search/railsListingPage?from_city=${fromCityName}&from=${fromCityCode}&from_station=${fromStationName}&to_city=${toCityName}&to=${toCityCode}&to_station=${toStationName}&departure=${formattedDate}`,
        universalText: _label('trains_from_to', undefined, {
          fromCity: fromCityName,
          toCity: toCityName,
          date: fecha.format(fromDateTime, "MMM D")
        }),
      },
    },
  };

  return searchParams;
};

export const getSectorInformation = (response, pageName) => {
  const { fromCity, toCity, trainNumber } = response;
  const sectorDetails = {
    lob: 'rails',
    sector: `${fromCity}-${toCity}`,
    pageName: pageName.toLowerCase(),
    products: [trainNumber],
  };
  return sectorDetails;
};
